export default __webpack_public_path__ + "static/media/setting_pink.e696e225.svg";